import { doc, getDoc } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { firebaseDb } from 'src/services/firebase-compat'

interface FilterApiConfig {
  internal_enabled: boolean
  external_enabled: boolean
  loading: boolean
}

/**
 * Hook to fetch Firebase config for which filter API to use (one-time read)
 * Firebase structure: configs/New_Filters → { internal_users: true/false, external_users: true/false }
 * Note: Uses getDoc instead of onSnapshot - config changes require page refresh
 */
export function useFilterApiConfig(): FilterApiConfig {
  const [internalEnabled, setInternalEnabled] = useState<boolean | null>(null)
  const [externalEnabled, setExternalEnabled] = useState<boolean | null>(null)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const newFiltersDocRef = doc(firebaseDb, 'configs/new_filters')
        const snapshot = await getDoc(newFiltersDocRef)

        const data = snapshot.data()
        const internalEnabled = data?.internal_users ?? true
        const externalEnabled = data?.external_users ?? false

        setInternalEnabled(internalEnabled)
        setExternalEnabled(externalEnabled)
      } catch (error) {
        console.error('[useFilterApiConfig] Error fetching New_Filters config:', error)
        setInternalEnabled(true)
        setExternalEnabled(false)
      }
    }

    fetchConfig()
  }, [])

  return {
    internal_enabled: internalEnabled ?? true,
    external_enabled: externalEnabled ?? false,
    loading: internalEnabled === null || externalEnabled === null
  }
}
